/* ChinaTourly Product Page payment buttons.
   DISABLED 2026-05-29 (owner brief 20260529-074544 item 4: remove the duplicate
   payment/CTA that this script injected under the "planner will reach out"
   consultation note). The single payment area now lives in the date/pricing
   section of sections/ct-route-product.liquid, where the full / 20% deposit
   checkout links are rendered server-side. This file is intentionally a no-op so
   any cached reference does nothing and never injects a second pay block.
   Original injector preserved in task evidence:
   .agent_hub/evidence/yegelite-20260529-074544-7d41b151/snapshots_before/assets__ct-product-pay-buttons.js
*/
(function () { /* no-op */ })();

/* CT 2026-06-11: route map cache fallback.
   Some password-gated product URLs can retain an older rendered Liquid page_cache
   even after the main ct-route section is updated. This existing product asset is
   already referenced by those cached pages, so use it only to load the route-map
   runtime corrector. The corrector is guarded and does not touch checkout logic. */
(function () {
  if (window.__ctRouteMapPayAssetLoader) return;
  window.__ctRouteMapPayAssetLoader = true;
  function loadRouteFix() {
    if (!document.querySelector('.ct-route-live-map')) return;
    if (window.__ctRouteMapRuntimeFix || document.querySelector('script[data-ct-route-map-runtime-fix]')) return;
    var script = document.createElement('script');
    script.src = '/cdn/shop/t/29/assets/ct-route-map-runtime-fix.js?ct=20260611-1340';
    script.defer = true;
    script.dataset.ctRouteMapRuntimeFix = '1';
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadRouteFix);
  else loadRouteFix();
  setTimeout(loadRouteFix, 1200);
})();
